import { render, staticRenderFns } from "./Commitment.vue?vue&type=template&id=0f654125&"
import script from "./Commitment.vue?vue&type=script&lang=js&"
export * from "./Commitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports